import { IMessageType } from '@/services/signalr/types';
import { ITripAttachmentReqMsg } from '~/api/messages/ITripAttachmentReqMsg';
import { ITripAttachmentRespMsg } from '~/api/messages/ITripAttachmentRespMsg';

export const TripAttachmentReqMsg: IMessageType<ITripAttachmentReqMsg, ITripAttachmentRespMsg> = {
  requestName: 'TripAttachmentReqMsg',
  responseName: 'TripAttachmentRespMsg',
};

export const RecurringTripAttachmentReqMsg: IMessageType<ITripAttachmentReqMsg, ITripAttachmentRespMsg> = {
  requestName: 'RecurringTripAttachmentReqMsg',
  responseName: 'RecurringTripAttachmentRespMsg',
};

export const TransportRequestAttachmentReqMsg: IMessageType<ITripAttachmentReqMsg, ITripAttachmentRespMsg> = {
  requestName: 'TransportRequestAttachmentReqMsg',
  responseName: 'TransportRequestAttachmentRespMsg',
};
